import {AbstractCommand} from "./abstract.command";
import {WeeklyWorkingTime} from "../domain/entities/weekly-working-time.entity";
import {CommandName} from "./command-name.enum";

export class UpdateWeeklyWorkingTimeCommand extends AbstractCommand<WeeklyWorkingTime> {

    public name: CommandName = CommandName.UPDATE_WEEKLY_WORKING_TIME;

    public tags = ['entity', 'update', 'weekly-working-time'];

    constructor(payload: WeeklyWorkingTime) {
        super('employee', payload.employee.uid, payload);
    }
}